module.exports = __webpack_public_path__ + "img/product-2-50.png?911155e3ade7aae73ade0f1327d88ae6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/product-2-50.png
// module id = 419
// module chunks = 0